import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './layout/Layout';
import { HomePage } from './pages/HomePage';
import { AinKhaledPage } from './pages/AinKhaledPage';
import { AlMaydanPage } from './pages/AlMaydanPage';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/ain-khaled" element={<AinKhaledPage />} />
        <Route path="/al-maydan" element={<AlMaydanPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
